export const markdownHeaderClasses = {
    h1: "heading-2xl",
    h2: "heading-xl",
    h3: "heading-lg",
    h4: "text-base font-semibold",
    h5: "text-sm font-semibold",
    h6: "text-sm font-regular italic",
};
export const markdownParagraphSize = "text-base leading-relaxed";
// A denser scale for reading surfaces with long, frequent content (chat replies), one step down
// from the default at every level so headings keep their hierarchy.
const compactHeaderClasses = {
    h1: "heading-lg",
    h2: "heading-base",
    h3: "heading-sm",
    h4: "text-sm font-semibold",
    h5: "text-sm font-semibold",
    h6: "text-sm font-regular italic",
};
export function markdownSizesFor(textSize) {
    return textSize === "sm"
        ? { paragraph: "text-sm leading-relaxed", headers: compactHeaderClasses }
        : { paragraph: markdownParagraphSize, headers: markdownHeaderClasses };
}
//# sourceMappingURL=markdownSizes.js.map